export default "/assets/images/life-saving-co-sensor.mp4?eaeedf9d1760981bcb13b403ed844469";